module.exports = __webpack_public_path__ + "./images/cf55a92dd970528c6653c8533bb28db7.webp";